export default __webpack_public_path__ + "static/media/1415 knife block B top.359a1550.png";